module.exports = __webpack_public_path__ + "static/media/wreck.5b92a14d.svg";